import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@bingads-webui-react/primitive';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { AccountSelectorCallout } from './account-selector-callout';
import { getAccountSelectorStyle } from './styles';

export function AccountSelector(props) {
  const {
    updateSearchHistorySelectorOptions,
    updateSelected,
    getSelectedScope,
    description,
    reportSchema,
    searchHistorySelectorOptions: searchHistorySelectorOptionsFromProps,
  } = props;
  const [isCalloutVisible, setIsCalloutVisible] = useState(false);
  const classes = useDefaultStyles(getAccountSelectorStyle);

  function toggleIsCalloutVisiable() {
    setIsCalloutVisible(!isCalloutVisible);
  }

  function handleApply(selected, additionalInfo) {
    toggleIsCalloutVisiable();
    updateSelected(selected);
    updateSearchHistorySelectorOptions(additionalInfo.searchHistorySelectorOptions);
  }

  function onAccountSelectorButtonClick() {
    toggleIsCalloutVisiable();
  }

  return (
    <React.Fragment>
      <Button
        onClick={onAccountSelectorButtonClick}
        className={`${classes.customToolbarItem} account-selector-button`}
      >
        <span className="text">
          {description}
        </span>
        <span className="caret" />
      </Button>
      {isCalloutVisible &&
        <AccountSelectorCallout
          target=".account-selector-button"
          getSelectedScope={getSelectedScope}
          reportSchema={reportSchema}
          onApply={handleApply}
          onDismiss={() => { setIsCalloutVisible(false); }}
          searchHistorySelectorOptions={searchHistorySelectorOptionsFromProps}
        />
      }
    </React.Fragment>
  );
}

AccountSelector.propTypes = {
  updateSearchHistorySelectorOptions: PropTypes.func.isRequired,
  updateSelected: PropTypes.func.isRequired,
  getSelectedScope: PropTypes.func.isRequired,
  description: PropTypes.string.isRequired,
  reportSchema: PropTypes.shape({}).isRequired,
  searchHistorySelectorOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
